import { GameEngine } from "./engine.js";
import { ludo } from "./games/ludo.js";
import { domino } from "./games/domino.js";
import { jackaroo } from "./games/jackaroo.js";
import { memory } from "./games/memory.js";
import { billiards } from "./games/billiards.js";
import { carrom } from "./games/carrom.js";

export * from "./engine.js";
export * from "./rng.js";
export * from "./physics.js";
export * from "./games/ludo.js";
export * from "./games/domino.js";
export * from "./games/jackaroo.js";
export * from "./games/memory.js";
export * from "./games/billiards.js";
export * from "./games/carrom.js";
export * from "./protocol.js";

export const ENGINES: Record<string, GameEngine> = {
  jackaroo,
  ludo,
  domino,
  carrom,
  billiards,
  memory,
};

export function getEngine(id: string): GameEngine | undefined {
  return Object.prototype.hasOwnProperty.call(ENGINES, id) ? ENGINES[id] : undefined;
}
export * from "./layout.js";
